import React, { Component } from 'react';
import { Button, Collapse, Alert } from 'reactstrap';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import size from 'lodash/size';
import axios from '../../axios';
import * as actionCreators from './../../modules/actions/index';
import './Analytics.css';
import TabBar from '../../components/TabBar/TabBar';
import Search from '../../components/Search/Search';
import DateFilter from '../../components/DateFilter/DateFilter';
import UsersMetricesUI from './Metrics/UsersMetrics';
import UsersGrid from './DataGrid/UsersGrid';
// import DataChartUI from './DataChart/UsersChart';
import DataChartUI from './DataChart/Chart';

import Loading from '../../hoc/Loading/Loading';
import * as url from '../../utils/url';
import ExportToCSV from './ExportToCsv/ExportToCsvUsers';
import { objectEncode } from '../../components/Shared/ReusablesUtils';
import NoDataFound from '../../assets/no-kpidata-range.png';

const searchByUserNamePlaceholder = 'Search users...';
const Filters = 'Filters';
const chartXAxesMessage = 'Data on the chart represents weekly aggregates, starting every Monday.';

// Temporary URL for API CALL which needs to be changed when application hosted to DEV server.

// const URL = 'http://10.0.2.155:8090/users/v1/user-metrics/';

class Analytics extends Component {
    constructor(props) {
        super(props);
        // console.log( this.props.user.organizationId )
        this.state = {
            isFilterCollapsed: false,
            searchObject: {
                metrics: ['chartsCreated', 'weeklyWinsAdded', 'toolsCreated', 'storiesCreated','usersCreated','groupsJoined'],
                // startDate: moment().subtract(1, 'month').toISOString(),
                startDate: this.props && this.props.user && this.props.user.organizationId?
                    moment(this.props.user.organizationId.createdDate).toISOString():
                    moment().subtract(1, 'month').toISOString(),
                endDate: moment().toISOString(),
                username: '',
            },
        };
    }
    componentDidMount() {
        // Fetching all users Tab Data
        this.fetchLatestData();
        // Fetching Users Tab Metrices
        this.props.onFetchUserMetrices();
    }
    modifyDateTimestamp = (momentDate, date) => {
        const dateSplit = momentDate.split('T');
        return `${dateSplit[0]}${date === 'startDate' ? 'T00:00:00Z' : 'T23:59:59Z'}`;
    }
    fetchLatestData = () => {
        const { searchObject: { metrics, startDate, endDate, username } } = this.state;
        
        const { user: { organizationId } } = this.props;
        const getFilterObject = {
            metrics: metrics.toString(),
            startDate: this.modifyDateTimestamp(startDate, 'startDate'),
            endDate: this.modifyDateTimestamp(endDate, 'endDate'),
            username : encodeURIComponent(username),
            organizationId: encodeURIComponent(organizationId._id)
        };
        axios.get(`${url.getUserData}${objectEncode(getFilterObject)}`).then(({ data }) => {
            // console.log("---",data.data.data)
            this.props.onFetchUserAnalyticsSuccess(data.data.data);
        });
    }
    toggleCollapse = () => {
        const { isFilterCollapsed } = this.state;
        this.setState({
            isFilterCollapsed: !isFilterCollapsed,
        });
    }

  handleSearch = (e) => {
      const { value } = e.target;
      this.setState({
          searchObject: {
              ...this.state.searchObject,
              username: value,
          },
      }, () => {
          this.fetchLatestData();
      });
  }
  handleMetricsFilter = (metricId, event) => {
      const { checked } = event.target;
      const { metrics } = this.state.searchObject;
      console.log(checked, metrics)
      if (checked && metrics !== undefined) {
          metrics.push(metricId);
      } else {
          metrics.splice(metrics.indexOf(metricId), 1);
      }
      this.setState({
          searchObject: {
              ...this.state.searchObject,
              metrics,
          },
      }, () => {
          this.fetchLatestData();
      });
  }
  handleStartDateChange = (date) => {
      this.setState({
          searchObject: {
              ...this.state.searchObject,
              startDate: date,
          },
      }, () => {
          this.fetchLatestData();
      });
  }
  handleEndDateChange = (date) => {
      this.setState({
          searchObject: {
              ...this.state.searchObject,
              endDate: date,
          },
      }, () => {
          this.fetchLatestData();
      });
  }
  render() {
      const { isFilterCollapsed, searchObject } = this.state;
      const { userAnalytics, userMetrices, history, onFetchUserAnalyticsSuccess } = this.props;

      return (
          <div className="mt70 analytics-form">
              <div className="row ml-0 mr-0 mb-3 text-size">
                  <div className="title-text">Metrics</div>
                  <TabBar activeTab="1" history={history} />
              </div>
              <div className="row p-0 m-0 height40">
                  <Search
                      placeholder={searchByUserNamePlaceholder}
                      handleSearch={this.handleSearch}
                      value={searchObject.username}
                  />
                  <div className="col-lg-2 filter-select col-md-3 col-sm-3 pl0 pr0">
                      <Button color="secondary-filled" onClick={this.toggleCollapse} className="filterBtnStyle">
                          <span className="tool-list-font">
                              <i className="flaticon-equalizer filterBtnTextStyle"></i>{Filters} {size(searchObject.metrics)}
                          </span>
                      </Button>
                  </div>
              </div>
              {/* <DateFilter
                  handleStartDateChange={this.handleStartDateChange}
                  handleEndDateChange={this.handleEndDateChange}
                  searchObject={searchObject}
              /> */}
              <div className="row p-0 m-0">
                  <Collapse isOpen={isFilterCollapsed} className="col-lg-12 col-sm-12 col-md-12 pr0 pl-0 width100" toggler="#toggler">
                      <UsersMetricesUI
                          userMetrices={userMetrices}
                          searchObject={searchObject}
                          handleMetricsFilter={this.handleMetricsFilter}
                      />
                  </Collapse >
              </div>
              <div>
                  <div className="dataChartStyle">
                      <div className="dataChartDisplay">
                          <DataChartUI
                            chartValue = "Overview"
                            chartAnalytics={userAnalytics}
                            chartMetrices={userMetrices}
                            searchObject={searchObject}
                          />
                          <Alert className="btmMargin0" color="light">{chartXAxesMessage}</Alert>
                          <p className="chartUseMsg">To zoom in, click and drag across the chart area. To zoom out, triple click on the chart area.</p>
                      </div>
                  </div>
                  {/* <div className="row">
                    {userAnalytics.length > 0 && (
                        <ExportToCSV
                            Analytics={userAnalytics}
                            userMetrices={userMetrices}
                        />
                    )}
                  </div> */}
              </div>
              {/* <div>
                  <UsersGrid
                      userAnalytics={userAnalytics}
                      userMetrices={userMetrices}
                      fetchLatest={this.fetchLatestData}
                      searchObject={searchObject}
                      onFetchUserAnalyticsSuccess={onFetchUserAnalyticsSuccess}
                  />
              </div> */}
          </div>
      );
  }
}

Analytics.propTypes = {
    userAnalytics: PropTypes.array,
    userMetrices: PropTypes.array,
    history: PropTypes.object,
    onFetchUserAnalyticsSuccess: PropTypes.func.isRequired,
    onFetchUserMetrices: PropTypes.func,
};
const mapStateToProps = state => ({
    userAnalytics: state.dashboard.UsersAnalytics,
    userMetrices: state.dashboard.UsersMetrics,
    user: state.user.profile
});
const mapDispatchToProps = dispatch => ({
    onFetchUserAnalyticsSuccess: (data) => dispatch(actionCreators.fetchUserAnalyticsSuccess(data)),
    onFetchUserMetrices: () => dispatch(actionCreators.fetchUserMetrices()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Loading(Analytics, axios));

